import { Route, Routes, useLocation, useNavigate } from "react-router";
import Home from "./pages/home";
import PageNotFound from "./pages/page-not-found";
import DashboardLayout from "./components/layout/DashboardLayout";
import Category from "./pages/category";
import AddCategory from "./pages/add-category";
import ProductList from "./pages/product-list";
import AddProduct from "./pages/add-product";
import Courses from "./pages/courses";
import AddCourses from "./pages/add-course";
import InvoicesList from "./pages/invoices-list";
import InvoiceDetail from "./pages/invoice-detail";
import FaqCategory from "./pages/faq-category";
import Faq from "./pages/faq";
import AddFaq from "./pages/add-faq";
import AddFaqCategory from "./pages/add-faq-category";
import AddTicketCategory from "./pages/add-ticket-category";
import ManagementInformationContactUs from "./pages/management-information-contact-us";
import Ticket from "./pages/ticket";
import TicketCategory from "./pages/ticket-category";
import AddTicket from "./pages/add-ticket";
import ManagementDiscountCode from "./pages/management-discount-code";
import AddDiscountCode from "./pages/add-discount-code";
import ShippingMethod from "./pages/shipping-method";
import AddShippingMethod from "./pages/add-shipping-method";
import SocialNetworkSetting from "./pages/social-network-setting";
import AddSocialMedia from "./pages/add-social-media";
import ContactInformation from "./pages/contact-information";
import AddContactInformation from "./pages/add-contact-information";
import Setting from "./pages/setting";
import { App as AppAnt } from "antd";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import DepartmentCategory from "./pages/department-category";
import SubCategory from "./pages/sub-category";
import AddDepartment from "./pages/add-department";
import AddSubCategory from "./pages/add-sub-category";
import ConnectedCourse from "./pages/connected-course";
import PrintManagement from "./pages/print-management";
import Blog from "./pages/blog";
import AddBlogCategory from "./pages/add-blog-category";
import BlogCategory from "./pages/blog-category";
import AddBlog from "./pages/add-blog";
import ManagementPage from "./pages/management-page/ManagementPage";
import ManagementPageDetail from "./pages/management-page-detail";
import ManagementSection from "./pages/management-section";
import Testimonial from "./pages/testimonial";
import AddTestimonial from "./pages/add-testimonial";
import Institution from "./pages/institution";
import AddInstitution from "./pages/add-institution";
import SliderPage from "./pages/slider-page";
import AddSlider from "./pages/add-slider";
import ListOfSeasons from "./pages/list-of-seasons";
import AddSeason from "./pages/add-season";
import ManageCourseFeatures from "./pages/manage-course-features";
import AddCourseFeature from "./pages/add-course-feature";
import AddVideoForSeason from "./pages/add-video-for-season";
import VideoList from "./pages/video-list";
import BranchList from "./pages/branch-list";
import AddBranch from "./pages/add-branch";
import AddPhoneNumberBranch from "./pages/add-phone-number-branch";
import AddTransportation from "./pages/add-transportation";
import ListPhoneNumberBranch from "./pages/list-phone-number-branch";
import ListTransportation from "./pages/list-transportation";
import CommentList from "./pages/comment-list";
import AddCertificate from "./pages/add-certificate";
import CertificateList from "./pages/certificate-list";
import CustomerList from "./pages/customer-list";
import AddCustomer from "./pages/add-customer";
import PermissionList from "./pages/permission-list";
import AddPermission from "./pages/add-permission";
import { useStore } from "zustand";
import { useToken } from "./store/token";
import Cookies from "js-cookie";
import { useEffect } from "react";

export default function App() {
  const { notification } = AppAnt.useApp();
  const pathname = useLocation();
  const navigate = useNavigate();
  const { setToken } = useStore(useToken);
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        notification.error({
          title: "خطا",
          description: error.message,
          placement: "topRight",
          showProgress: true,
          type: "error",
          classNames: {
            root: "custom-notification-error",
          },
        });
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        notification.error({
          title: "خطا",
          description: error?.message || "عملیات ناموفق بود",
          placement: "topRight",
          showProgress: true,
          type: "error",
          classNames: {
            root: "custom-notification-error",
          },
        });
      },
    }),
  });

  useEffect(() => {
    if (!Cookies.get("token")) {
      setTimeout(() => {
        navigate(
          `https://rashed-demo-student.modirino.com/login?callback=${pathname.pathname}`,
        );
      }, 50);
    } else {
      setToken(`Bearer ${Cookies.get("token")}`);
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        {/* ------------------------------------------- */}
        <Route element={<DashboardLayout />}>
          <Route index element={<Home />} />
          {/* category */}
          <Route path="category" element={<Category />} />
          <Route path="category/add-category" element={<AddCategory />} />
          {/* product-list */}
          <Route path="product-list" element={<ProductList />} />
          <Route path="product-list/add-product" element={<AddProduct />} />
          {/* course */}
          <Route path="connected-course/:id" element={<ConnectedCourse />} />
          <Route path="department-category" element={<DepartmentCategory />} />
          <Route
            path="department-category/:departmentId/*"
            element={<SubCategory />}
          />
          <Route
            path="department-category/:departmentId/:category_u_id?/add-sub-category"
            element={<AddSubCategory />}
          />
          <Route
            path="manage-course-features"
            element={<ManageCourseFeatures />}
          />
          <Route path="add-course-feature" element={<AddCourseFeature />} />
          <Route
            path="department-category/add-department"
            element={<AddDepartment />}
          />
          <Route path="courses" element={<Courses />} />
          <Route path="courses/add-course" element={<AddCourses />} />
          {/* seasons */}
          <Route path="list-of-seasons/:id" element={<ListOfSeasons />} />
          <Route path="add-season/:id" element={<AddSeason />} />
          <Route path="video-list/:id" element={<VideoList />} />
          <Route
            path="add-video-for-season/:id"
            element={<AddVideoForSeason />}
          />
          {/* invoice */}
          <Route path="invoices-list" element={<InvoicesList />} />
          <Route path="invoice-detail/:id" element={<InvoiceDetail />} />
          {/* faq */}
          <Route path="faq-category" element={<FaqCategory />} />
          <Route path="add-faq-category" element={<AddFaqCategory />} />
          <Route path="faq" element={<Faq />} />
          <Route path="add-faq" element={<AddFaq />} />
          {/* support */}
          <Route path="ticket" element={<Ticket />} />
          <Route path="add-ticket" element={<AddTicket />} />
          <Route path="ticket-category" element={<TicketCategory />} />
          <Route path="add-ticket-category" element={<AddTicketCategory />} />
          <Route
            path="management-information-contact-us"
            element={<ManagementInformationContactUs />}
          />
          {/* discount code */}
          <Route
            path="management-discount-code"
            element={<ManagementDiscountCode />}
          />
          <Route path="add-discount-code" element={<AddDiscountCode />} />

          {/* print management */}
          <Route path="print-management" element={<PrintManagement />} />

          {/* shipping method */}
          <Route path="shipping-method" element={<ShippingMethod />} />
          <Route path="add-shipping-method" element={<AddShippingMethod />} />
          {/* management information */}
          {/* social-media */}
          <Route
            path="social-network-setting"
            element={<SocialNetworkSetting />}
          />
          <Route path="add-social-media" element={<AddSocialMedia />} />
          {/* blog */}
          <Route path="blog" element={<Blog />} />
          <Route path="blog-category" element={<BlogCategory />} />
          <Route path="add-blog-category" element={<AddBlogCategory />} />
          <Route path="add-blog" element={<AddBlog />} />
          {/* contact information */}
          <Route path="contact-information" element={<ContactInformation />} />
          <Route
            path="add-contact-information"
            element={<AddContactInformation />}
          />
          {/* setting */}
          <Route path="setting" element={<Setting />} />
          <Route path="management-page" element={<ManagementPage />} />
          <Route
            path="management-page/:id"
            element={<ManagementPageDetail />}
          />
          <Route
            path="management-page/:id/:sectionId"
            element={<ManagementSection />}
          />
          {/* management-page-content */}
          {/* testimonial */}
          <Route path="testimonial" element={<Testimonial />} />
          <Route path="add-testimonial" element={<AddTestimonial />} />
          {/* institution */}
          <Route path="institution" element={<Institution />} />
          <Route path="add-institution" element={<AddInstitution />} />
          {/* slider */}
          <Route path="slider-page" element={<SliderPage />} />
          <Route path="add-slider" element={<AddSlider />} />
          {/* branch */}
          <Route path="branch-list" element={<BranchList />} />
          <Route path="add-branch" element={<AddBranch />} />
          <Route
            path="list-phone-number-branch/:id"
            element={<ListPhoneNumberBranch />}
          />
          <Route
            path="list-transportation/:id"
            element={<ListTransportation />}
          />
          <Route path="add-branch/:id" element={<AddBranch />} />
          <Route
            path="add-phone-number-branch/:id"
            element={<AddPhoneNumberBranch />}
          />
          <Route
            path="add-transportation/:id"
            element={<AddTransportation />}
          />
          {/* comments */}
          <Route path="courses/comment-list/:id" element={<CommentList />} />
          {/* customer */}
          <Route path="customer-list" element={<CustomerList />} />
          <Route path="customer-list/add-customer" element={<AddCustomer />} />
          {/* certificate */}
          <Route path="certificate-list" element={<CertificateList />} />
          <Route
            path="certificate-list/add-certificate"
            element={<AddCertificate />}
          />
          {/* permission */}
          <Route path="permission-list" element={<PermissionList />} />
          <Route
            path="permission-list/add-permission"
            element={<AddPermission />}
          />
        </Route>

        {/* 404 page */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </QueryClientProvider>
  );
}
